import React, { useState, useEffect } from 'react';
import { supabase } from '../../../config/supabase';
import './TopSellingItems.css';

const TopSellingItems = () => {
  const [topItems, setTopItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTopItems();
  }, []);

  const fetchTopItems = async () => {
    setLoading(true);
    try {
      const { data: orders, error } = await supabase
        .from('orders')
        .select('items')
        .order('created_at', { ascending: false })
        .limit(500); // Get recent 500 orders

      if (error) throw error;

      // Count item occurrences and calculate revenue
      const itemStats = {};
      (orders || []).forEach(order => {
        const items = typeof order.items === 'string' ? JSON.parse(order.items) : order.items;
        items.forEach(item => {
          const itemName = item.name || 'Unknown Item';
          if (!itemStats[itemName]) {
            itemStats[itemName] = { orders: 0, revenue: 0 };
          }
          itemStats[itemName].orders += item.quantity || 1;
          itemStats[itemName].revenue += parseFloat(item.finalPrice || item.price || 0) * (item.quantity || 1);
        });
      });

      // Convert to array, sort by orders, and get top 10
      const itemsArray = Object.entries(itemStats)
        .map(([name, stats], index) => ({
          rank: index + 1,
          name,
          orders: stats.orders,
          revenue: Math.round(stats.revenue)
        }))
        .sort((a, b) => b.orders - a.orders)
        .slice(0, 10);

      setTopItems(itemsArray);
    } catch (error) {
      console.error('Error fetching top items:', error);
      setTopItems([]);
    } finally {
      setLoading(false);
    }
  };

  const maxOrders = topItems.length > 0 ? Math.max(...topItems.map(item => item.orders)) : 1;

  const getRankIcon = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return rank;
  };

  const formatCurrency = (amount) => {
    return `Rs. ${amount.toLocaleString()}`;
  };

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Top 10 Selling Items</h3>
          <p className="chart-subtitle">Best performers</p>
        </div>
      </div>

      <div className="top-items-list">
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#6C757D' }}>Loading data...</div>
        ) : topItems.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#6C757D' }}>No items data available</div>
        ) : (
          topItems.map(item => (
          <div key={item.rank} className="top-item-row">
            <div className="item-rank">
              {getRankIcon(item.rank)}
            </div>
            <div className="item-info">
              <div className="item-name">{item.name}</div>
              <div className="item-stats">
                <span className="item-orders">{item.orders} orders</span>
                <span className="item-separator">•</span>
                <span className="item-revenue">{formatCurrency(item.revenue)}</span>
              </div>
              <div className="item-progress-bar">
                <div
                  className="item-progress-fill"
                  style={{ width: `${(item.orders / maxOrders) * 100}%` }}
                />
              </div>
            </div>
          </div>
        ))
        )}
      </div>
    </div>
  );
};

export default TopSellingItems;

